

export function Divider() {
    return <div style={{ height: 20, width: 1, background: '#ffffff20', marginInline: '1.5rem' }} />
}